import { generateClient } from 'aws-amplify/api';
import { listStaff } from '../graphql/queries';
import * as mutations from '../graphql/mutations';

const client = generateClient();

// Fetch all staff members
export const fetchStaff = async () => {
  try {
    const result = await client.graphql({ query: listStaff });
    const staff = result.data.listStaff.items.map((item) => ({
      id: item.id,
      name: item.name,
      role: item.role,
      description: item.description,
      certificates: item.certificates || "",
      experience: item.experience || "",
      imageUrl: item.imageUrl,
    }));
    return staff;
  } catch (error) {
    console.error('Failed to fetch staff:', error);
    throw error;
  }
};

// Add a new staff member
export const addStaff = async (name, role, description, certificates, experience, imageUrl) => {
  try {
    const response = await client.graphql({
      query: mutations.createStaff,
      variables: { input: { name, role, description, certificates, experience, imageUrl } }
    });

    if (response.data && response.data.createStaff) {
      console.log('Create response:', response.data.createStaff);
      alert('Staff member added successfully');
      return response.data.createStaff;
    } else {
      console.error('Failed to add staff member');
      alert('Failed to add staff member');
    }
  } catch (error) {
    console.error('Add failed:', error);
    alert('Error during addition');
    throw error;
  }
};

// Delete a staff member
export const deleteStaff = async (id) => {
  try {
    const response = await client.graphql({
      query: mutations.deleteStaff,
      variables: { input: { id } }
    });

    if (response.data && response.data.deleteStaff) {
      console.log('Delete response:', response.data.deleteStaff);
      alert('Staff member deleted successfully');
    } else {
      console.error('Failed to delete staff member: No deleteStaff data');
      alert('Failed to delete staff member');
    }
  } catch (error) {
    console.error('Delete failed:', error);
    alert('Error during deletion');
  }
};

// Edit a staff member
export const editStaff = async (id, updatedStaffDetails) => {
  const staffDetails = {
    id,
    ...updatedStaffDetails
  };

  try {
    const response = await client.graphql({
      query: mutations.updateStaff,
      variables: { input: staffDetails }
    });

    if (response.data && response.data.updateStaff) {
      console.log('Edit response:', response.data.updateStaff);
      return response.data.updateStaff;
    } else {
      console.error('Failed to update staff member: No updateStaff data');
      alert('Failed to update staff member');
    }
  } catch (error) {
    console.error('Update failed:', error);
    alert('Error during update');
    throw error;
  }
};